document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const resultsContainer = document.getElementById("predictive-search-results");

  if (!searchInput || !resultsContainer) return;

  // Define menu items to be included in search results
  const menuItems = {
    courses: [
       { name: "Khan Academy Courses", url: "https://www.khanacademy.org/" },
       { name: "Assorted", url: "https://www.naviata.com/pages/online-courses" },
       { name: "Free YouTube Courses", url: "https://www.classcentral.com/provider/youtube" },
       { name: "Microsoft Learn Courses", url: "https://www.classcentral.com/provider/microsoft-learn" },
       { name: "Coursera", url: "https://www.coursera.org/" },
       { name: "edX", url: "https://www.udemy.com/" },
       { name: "MIT OpenCourseWare", url: "https://ocw.mit.edu/" },
       { name: "Udemy", url: "/courses/udemy" },
       { name: "Alison", url: "https://alison.com/" },
       { name: "17 Free Websites", url: "https://brittanywashburn.com/2020/08/17-free-educational-websites-for-high/" },
       { name: "CK-12", url: "https://www.ck12.org/student/" },
       { name: "Edmentum", url: "https://www.edmentum.com/" },
       { name: "Study.com", url: "https://study.com/" },
       { name: "Shmoop", url: "https://www.shmoop.com/" },
       { name: "Thinkwell", url: "https://www.thinkwell.com/" },
    ],
    application: [
      { name: "Common App", url: "/application/common-app" },
      { name: "Coalition App", url: "/application/coalition-app" },
      { name: "Universal College Application", url: "/application/universal-college-application" },
      { name: "UC Application", url: "/application/uc-application" },
      { name: "SUNY Application", url: "/application/suny-application" },
      { name: "ApplyTexas", url: "/application/applytexas" },
      { name: "Appily", url: "/application/appily" },
      { name: "Common Black Application", url: "/application/common-black-application" },
      { name: "Texas A&M", url: "/application/texas-am" },
      { name: "Cal State Apply", url: "/application/cal-state-apply" },
    ],
    jobs: [
      { name: "CollegeGrad", url: "https://collegegrad.com/" },
       { name: "FlexJobs", url: "https://www.flexjobs.com/" },
      { name: "Indeed", url: "https://www.indeed.com/q-usa-student-jobs.html?vjk=1f46a1159ea3257b" },
      { name: "Monster", url: "https://www.monster.com/" },
      { name: "USAJOBS", url: "https://www.usajobs.gov/" },
      { name: "ZipRecruiter", url: "https://www.ziprecruiter.com/college-jobs" },
      { name: "Career Profiles", url: "https://www.careerprofiles.com/" },
    ],
    news: [
      { name: "EdWeek", url: "https://www.edweek.org/teaching-learning/motivating-all-students-to-be-stem-problem-solvers" },
      { name: "IHE", url: "https://www.insidehighered.com/" },
      { name: "Chronical", url: "https://www.chronicle.com/" },
      { name: "K-12DIVE", url: "https://www.k12dive.com/" },
      { name: "USAJOBS", url: "https://www.usajobs.gov/" },
     
    ],
  };

  searchInput.addEventListener("input", function () {
    let query = searchInput.value.trim().toLowerCase();

    if (query.length < 2) {
      resultsContainer.innerHTML = "";
      resultsContainer.style.display = "none";
      return;
    }

    fetch(`/search/suggest.json?q=${query}&resources[type]=page&resources[limit]=5`)
      .then((response) => response.json())
      .then((data) => {
        displayResults(data.resources.results.pages, query);
      })
      .catch((error) => console.error("Error fetching search results:", error));
  });

  function displayResults(pages, query) {
    let resultsHTML = '<ul class="predictive-search-list">';
    let foundResults = false; // Track if any results were found

    const displayedUrls = new Set(); // To track already displayed URLs

    // Search menu items dynamically
    Object.keys(menuItems).forEach((category) => {
      if (query.includes(category)) {
        foundResults = true;
        resultsHTML += `
          <li class="predictive-search-item">
            <div class="dropdown">
              <span class="dropdown-title">${category.charAt(0).toUpperCase() + category.slice(1)}</span>
              <ul class="dropdown-list">
        `;
        menuItems[category].forEach((item) => {
          // Check if the URL has already been displayed
          if (!displayedUrls.has(item.url)) {
            resultsHTML += `<li><a href="${item.url}">${item.name}</a></li>`;
            displayedUrls.add(item.url); // Mark the URL as displayed
          }
        });
        resultsHTML += `</ul></div></li>`;
      }
    });

    if (query.includes("home")) {
  window.location.href = "/"; // Redirect to the Home page
}


    // Search in pages from Shopify search API
    // if (pages.length > 0) {
    //   foundResults = true;
    //   pages.forEach((page) => {
    //     if (!displayedUrls.has(page.url)) {
    //       resultsHTML += `
    //         <li class="predictive-search-item">
    //           <a href="${page.url}">
    //             <span>${page.title}</span>
    //           </a>
    //         </li>`;
    //       displayedUrls.add(page.url); // Mark the URL as displayed
    //     }
    //   });
    // }

    // Search in the Shopify menu items (from the window.shopifyMenus array)
    window.shopifyMenus.forEach((menuItem) => {
      if (menuItem.title.toLowerCase().includes(query) && !displayedUrls.has(menuItem.url)) {
        foundResults = true;
        resultsHTML += `
          <li class="predictive-search-item">
            <a href="${menuItem.url}">
              <span>${menuItem.title}</span>
            </a>
          </li>
        `;
        displayedUrls.add(menuItem.url); // Mark the URL as displayed
      }
    });

    // if (!foundResults) {
    //   resultsHTML += "<p>No results found.</p>";
    // }

    resultsHTML += "</ul>";
    resultsContainer.innerHTML = resultsHTML;
    resultsContainer.style.display = "block";
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   const searchInput = document.getElementById("search-input");
//   const resultsContainer = document.getElementById("predictive-search-results");

//   if (!searchInput || !resultsContainer) return;

//   searchInput.addEventListener("input", function () {
//     let query = searchInput.value.trim().toLowerCase();

//     if (query.length < 2) {
//       resultsContainer.innerHTML = "";
//       resultsContainer.style.display = "none";
//       return;
//     }

//     let resultsHTML = '<ul class="predictive-search-list">';
//     let foundResults = false;

//     // Search in the Shopify menu items (from the window.shopifyMenus array)
//     window.shopifyMenus.forEach((menuItem) => {
//       if (menuItem.title.toLowerCase().includes(query)) {
//         foundResults = true;
//         resultsHTML += `
//           <li class="predictive-search-item">
//             <a href="${menuItem.url}">
//               <span>${menuItem.title}</span>
//             </a>
//           </li>
//         `;
//       }
//     });

//     // If no menu results are found, show a message
//     if (!foundResults) {
//       resultsHTML += "<p>No results found.</p>";
//     }

//     resultsHTML += "</ul>";
//     resultsContainer.innerHTML = resultsHTML;
//     resultsContainer.style.display = "block";
//   });
// });


